"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var mobx_react_1 = require("mobx-react");
var Dropdown_1 = require("office-ui-fabric-react/lib/Dropdown");
var React = require("react");
var store_1 = require("../data/store/store");
var owa_session_store_1 = require("owa-session-store");
var selectTimeZoneOption_1 = require("../data/mutators/selectTimeZoneOption");
var owa_options_strings_1 = require("owa-strings/owa-options-strings");
// const styles = require('./Regional.scss');
var TimeZoneSelection = /** @class */ (function (_super) {
    tslib_1.__extends(TimeZoneSelection, _super);
    function TimeZoneSelection() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    TimeZoneSelection.prototype.render = function () {
        var store = store_1.default();
        return (React.createElement(Dropdown_1.Dropdown, { label: owa_options_strings_1.default.option_regional_timeZone, options: store.supportedTimeZones.map(function (timeZone) { return ({
                text: timeZone.Name,
                key: timeZone.Value,
            }); }), selectedKey: store.selectedTimeZone || owa_session_store_1.getUserConfiguration().UserOptions.TimeZone, onChanged: this.onSelectDateFormat }));
    };
    TimeZoneSelection.prototype.onSelectDateFormat = function (item) {
        selectTimeZoneOption_1.default(item.key);
    };
    TimeZoneSelection = tslib_1.__decorate([
        mobx_react_1.observer
    ], TimeZoneSelection);
    return TimeZoneSelection;
}(React.Component));
exports.default = TimeZoneSelection;
//# sourceMappingURL=TimeZoneSelection.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/options/config/general/owa-regional-option/lib/view/TimeZoneSelection.js
// module id = 4942
// module chunks = 2